const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2.85 22c0-5.51 4.1-10 9.15-10s9.15 4.48 9.15 9.99H2.85zM8.08 8.25v-2.5C8.08 3.68 9.84 2 12 2s3.92 1.68 3.92 3.75v2.5c0 2.07-1.76 3.75-3.92 3.75s-3.92-1.68-3.92-3.75z",
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15.44 11.62C16.39 10.71 17 9.43 17 8V6c0-2.76-2.24-5-5-5S7.03 3.24 7.03 6v2c0 1.43.58 2.71 1.54 3.62A9.969 9.969 0 002.03 21v1c0 .55.42 1 .97 1h18c.55 0 1-.45 1-1v-1c0-4.31-2.74-7.98-6.56-9.38zM9 8V6c0-1.65 1.35-3 3-3s3 1.35 3 3v2c0 1.65-1.35 3-3 3S9 9.65 9 8zM4 21c0-4.41 3.59-8 8-8s8 3.59 8 8z",
  fill: "#8fb0d4"
});

const SvgAvatarDefault = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAvatarDefault, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/avatar-default.46edd953.svg";
export { ForwardRef as ReactComponent };